import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { PagesPaginateModel } from "../../../../models/Paginate/PagesPaginate";
import { StatusService } from "../../../../services/Financial/Coupons/Status/StatusServices";

interface ContextProps {
  params: any;
  setParams: Dispatch<SetStateAction<any>>;
  status: any[];
  statusOptions: any[];
  pages: PagesPaginateModel;
  setPages: Dispatch<SetStateAction<PagesPaginateModel>>;
  isLoading: boolean;
  isLoadingModal: boolean;
  error: string;
  setError: Dispatch<SetStateAction<string>>;
  handleListStatus: (params: any) => void;
}

export const StatusContext = createContext<ContextProps>({} as ContextProps);

interface StatusProviderProps {
  children: ReactNode;
}

export const StatusProvider = ({ children }: StatusProviderProps) => {
  const [params, setParams] = useState<any>(null);
  const [pages, setPages] = useState<PagesPaginateModel>({});
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingModal, setIsLoadingModal] = useState<boolean>(true);
  const [error, setError] = useState<string>("");
  const [status, setStatus] = useState<any[]>([]);
  const [statusOptions, setStatusOptions] = useState<any | null>(null);

  const service = new StatusService();

  const handleListStatus = useCallback(
    async (params: any) => {
      try {
        setIsLoading(true);
        const [_Response, _Error] = await service.list(params);
        setIsLoading(false);

        if (!!_Error) {
          return setError(_Response?.message || _Error);
        }

        setStatus(_Response?.data?.items);
        setPages(_Response?.data?.pagination);
        return setError("");
      } catch (e) {
        setIsLoading(false);
        setError("Não foi possível carregar os planos do sistema.");
      }
    },
    [params],
  );

  useEffect(() => {
    setStatusOptions(
      status?.map((item: any) => ({
        label: item?.name,
        value: item?.id,
      })),
    );
  }, [status]);

  return (
    <StatusContext.Provider
      value={{
        params,
        setParams,
        status,
        pages,
        statusOptions,
        setPages,
        isLoading,
        isLoadingModal,
        error,
        setError,
        handleListStatus,
      }}
    >
      {children}
    </StatusContext.Provider>
  );
};

export const useStatus = () => useContext(StatusContext);
